/*
 * DO NOT EDIT js/compiled/ai-helpers.js
 * ALL EDITING IS DONE IN js/src/ai-helpers.js AND COMPILED WITH BABEL
 * grunt or grunt compile
*/

'use strict';

const add_commas = function(number) {
    // convert to string for regex processing
    if (number !== false && number !== null && number !== undefined && number !== "") {
        let string_number = number.toString();
        // add thousands separator
        let x = string_number.split('.');
        let x1 = x[0];
        let x2 = x.length > 1 ? '.' + x[1] : '';
        let rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        let result = x1 + x2;
        return result;
    } else {
        return '';
    }
};

const adjust_brightness = function( hex, steps, replacements ) {
    // Steps should be between -255 and 255. Negative = darker, positive = lighter
    steps = Math.max( -255, Math.min( 255, Number(steps) ) );
    // Normalize into a six character long hex string
    hex = hex.replace( '#', '', hex );
    // Split into three parts: R, G and B and convert to decimal
    let rgb = hex_to_rgb(hex);
    let new_hex_parts = [];
    for(let i = 0; i < rgb.length; i++ ) {
        let color = rgb[i];
        // Adjust color
        color = Math.max( 0, Math.min( 255, color + steps ) );
        // Convert to hex code
        let new_hex = color.toString(16);
        if(new_hex.length < 2) {
            new_hex = new_hex + new_hex;
        }
        new_hex_parts.push(new_hex);
    }

    if(new_hex_parts.indexOf('ff') > -1 && new_hex_parts.indexOf('00') > -1 && replacements) {
      if(steps < 0) {
        new_hex_parts[new_hex_parts.indexOf('ff')] = replacements.dark;
      } else if(steps > 0) {
        new_hex_parts[new_hex_parts.indexOf('00')] = replacements.light;
      }

    }
    //console.log(steps, rgb);
    return '#'+new_hex_parts.join('');
};

const ajax_load = function(settings) {
    //console.log(settings);
    let from_container_id = settings.from.replace('#', '');
    let to_container_id = settings.to ? settings.to.replace('#', '') : from_container_id;
    let append = settings.append ? settings.append : false;
    let request_url = settings.url;
    let scroll = settings.scroll ? settings.scroll : false;
    let modal = settings.modal ? settings.modal : false;
    let loading_element_id = settings.loading_element_id ? settings.loading_element_id : to_container_id;
    let request = new XMLHttpRequest();
    request.open('GET', request_url, true);
    request.responseType = 'document';
    request.send();
    request.overrideMimeType('text/html');
    // Loader
    document.getElementById(loading_element_id).classList.add('loading');
    request.onreadystatechange = function() {
        if(request.readyState == 2) {
            // Scroll
            if(scroll) {
                document.getElementById(to_container_id).scrollIntoView();
            }
        }
        if(request.readyState == 4 && request.status == 200) {
            if(request.responseXML) {
                // Results
                let request_results = request.responseXML;
                // Load content
                let from_container = request_results.getElementById(from_container_id);
                let from_container_html = from_container ? from_container.innerHTML : '';
                let to_container = document.getElementById(to_container_id);
                let output = '';
                if(modal) {
                    output += '<div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">';
                    output += '<button class="uk-modal-close-default" type="button" uk-close></button>';
                }
                output += from_container_html;
                if(modal) {
                    output += '</div>';
                }
                // Are we appending or overwriting?
                if(append) {
                    to_container.insertAdjacentHTML('beforeend', output);
                } else {
                    to_container.innerHTML = output;
                }
                // Head
                //let new_head = request_results.getElementsByTagName('head')[0].innerHTML;
                //let old_head = document.getElementsByTagName('head')[0];
                //old_head.innerHTML = new_head;

                /*
                // pushState(state object, title, URL
                let new_url = request_results.querySelector('meta[property="og:url"]').getAttribute('content');
                let new_title = request_results.getElementsByTagName('title')[0].innerHTML;
                let state_object = {
                    content: from_container_html,
                    class: new_title,
                };
                history.pushState(state_object, new_title, new_url);

                // on history back or forward
                window.onpopstate = function(e) {
                    e.preventDefault();
                    ajax_load({from: from_container_id, to: to_container_id, url: location.href});
                };
                */

                // Put body id as class on to_container
                let new_body_tag = request_results.getElementsByTagName('body')[0];
                let new_body_id = new_body_tag.getAttribute('id');
                let new_body_class = new_body_tag.getAttribute('class');
                //let body = document.getElementsByTagName('body')[0];
                if(new_body_id) {
                    to_container.classList.add(new_body_id);
                }
                //else {
                //    body.removeAttribute('id');
                //}
                //if(new_body_class) {
                //    body.setAttribute('class', new_body_class);
                //}
                //else {
                //    body.removeAttribute('class');
                //}

                // Callbacks
                let callbacks = 0;
                for ( let prop in settings ) {
                    if ( settings.hasOwnProperty( prop ) && prop.search( 'callback_' ) > -1 ) {
                        callbacks++;
                    }
                }
                let i = 1;
                do {
                    //console.log(settings[ 'callback_' + i ]);
                    //console.log(settings['callback_' + i].indexOf('new '));
                    //console.log(typeof settings['callback_' + i].replace('new '));
                    if(settings[ 'callback_' + i ] != undefined && typeof window[ settings['callback_' + i] ] == 'function' ) {
                        //return;
                        let arg = settings[ 'arg_' + i ] ? settings[ 'arg_' + i ] : '';
                        eval(settings[ 'callback_' + i ]+'('+arg+')');
                    } else if(settings[ 'callback_' + i ] != undefined && settings['callback_' + i].indexOf('new ') > -1) {
                        eval(settings['callback_' + i]);
                    }
                    i++;
                }
                while (i <= callbacks);

                // Load defered stuff
                window_onload();

                // Remove loader
                if(document.getElementById(loading_element_id)) {
                   document.getElementById(loading_element_id).classList.remove('loading');
                }
            }
        }
    };
};

// Searches an array for a string up to two levels deep
const array_find = function( needle, haystack, _keep_going, search_keys ) {
	let keep_going = _keep_going == null ? true : _keep_going;
    let keys = [];
	for( let key in haystack ) {
        let value = haystack[key];
		if ( typeof value != 'object' ) {
			// Search key
			if ( search_keys && ( key.includes(needle) || key === needle ) ) {
				keys.push(key);
			}
			// Search value
			else if ( value.includes(needle) || value === needle ) {
				keys.push(key);
			}
		} else if ( keep_going ) {
		    for( let value_key in value ) {
                let value_value = value[value_key];
		        if ( typeof value_value != 'object' ) {
    		        // Search key
                    if ( search_keys && ( value_key.includes(needle) || value_key === needle ) ) {
                        keys.push(key);
                    }
                    // Search value
                    else if ( value_value.includes(needle) || value_value == needle ) {
                        keys.push(key);
                    }
                } else {
                    for( let value_value_key in value_value ) {
                        let value_value_value = value_value[value_value_key];
                        if ( typeof value_value_value != 'object' ) {
                            // Search key
                            if ( search_keys && value_value_key.includes(needle) ) {
                                keys.push(key);
                            }
                            // Search value
                            else if ( value_value_value.includes(needle) ) {
                                keys.push(key);
                            }
                        }
                    }
                }
		    }
		}
	}
	if ( keys.length ) {
		return array_unique( keys );
	} else {
		return false;
	}
}

const array_sum = function(array) {
    let sum = array.reduce(add, 0);
    function add(a, b) {
        return a + b;
    }
    return sum;
};

const array_unique = function( array ) {
    let unique = [];
    for(let i = 0; i < array.length; i++) {
        let item = array[i];
        if(! unique.includes(item)) {
            unique.push(item);
        }
    }
    return unique;
}

const ai_document_ready = function(function_to_execute) {
    // Modern Browsers
    if(document.addEventListener) {
        if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
            function_to_execute();
        } else {
            document.addEventListener("DOMContentLoaded", function_to_execute);
        }
    }
    // Older browsers
    else if(document.attachEvent) {
        document.attachEvent("onreadystatechange", function(){
            // check if the DOM is fully loaded
            if(document.readyState === "complete"){
                // remove the listener, to make sure it isn't fired in future
                document.detachEvent("onreadystatechange", arguments.callee);
                // The actual handler...
                //console.log('ready old');
                eval('function_to_execute');
            }
        });
    }
}

// Lowercase first character
const first_toLowerCase = function(str) {
    return str.substr(0, 1).toLowerCase() + str.substr(1);
};

// Format Number
const format_number = function( number, label, space, decimals ) {
    if ( typeof number != 'number' ) return;
    decimals = decimals !== undefined ? decimals : 1;
    let trillion = 1000000000000;
    let billion = 1000000000;
    let million = 1000000;
    let thousand = 1000;
    if ( number >= trillion ) {
        let number_label = label == 'full' ? 'Trillion' : 'T';
        let number_formatted = addCommas( round( number, decimals, trillion ) );
        if (space) {
            number_formatted += '\u00A0';
        }
        number_formatted += number_label;
    } else if ( number >= billion ) {
        let number_label = label == 'full' ? 'Billion' : 'B';
        let number_formatted = addCommas( round( number, decimals, billion ) );
        if (space) {
            number_formatted += '\u00A0';
        }
        number_formatted += number_label;
    } else if ( number >= million ) {
        let number_label = label == 'full' ? 'Million' : 'M';
        let number_formatted = addCommas( round( number, decimals, million ) );
        if (space) {
            number_formatted += '\u00A0';
        }
        number_formatted += number_label;
    } else if ( number >= thousand ) {
        let number_label = label == 'full' ? 'Thousand' : 'K';
        let number_formatted = addCommas( round( number, decimals, thousand ) );
        if (space) {
            number_formatted += '\u00A0';
        }
        number_formatted += number_label;
    } else {
        let number_formatted = addCommas( number );
    }
    return number_formatted;
};

const ai_percent = function( numerator, denominator, adjust_for_0 ) {
    adjust_for_0 = adjust_for_0 !== null ? adjust_for_0 : true;
    if ( denominator ) {
        let raw_percent = ( numerator / denominator ) * 100;
    } else {
        let raw_percent = numerator * 100;
    }
    if ( raw_percent < .1 && adjust_for_0 ) {
        let percent = round( raw_percent, 2 );
    } else if ( raw_percent < 1 && adjust_for_0 ) {
        let percent = round( raw_percent, 1 );
    } else {
        let percent = round( raw_percent, 0 );
    }
    return percent;
};

const get_brightness = function(hex_color) {
    let rgb_color = hex_to_rgb(hex_color);
    return 0.2126 * rgb_color[0] + 0.7152 * rgb_color[1] + 0.0722 * rgb_color[2]; // per ITU-R BT.709
};

const get_cookies = function() {
    let cookies_raw = document.cookie.split('; ');
    let cookies = {};
    for(let i = 0; i < cookies_raw.length; i++) {
        let cookie = cookies_raw[i].split('=');
        if(cookie[0]) {
            cookies[cookie[0]] = cookie[1] ? cookie[1] : '';
        }
    }
    return cookies;
};

// From https://stackoverflow.com/a/9040869
const get_element_offset = function(element){
    let offset = {left:0, top:0};
    do {
        offset.left += element.offsetLeft;
        offset.top += element.offsetTop;
    }
    while (element = element.offsetParent);
    return offset;
}

const get_object_column = function(obj, column) {
    let results_array = [];
    for(let key in obj) {
        results_array.push(obj[key][column]);
    }
    return results_array;
};

// Get the specified parent element
const get_parent = function(element, parent_selector) {
    // element and parent_selector are required
    if(!element || !parent_selector) {
        return;
    }
    // Determine the type of parent_selector and act accordingly
    // ID
    if(parent_selector.indexOf('#') == 0) {
        let parent_id = parent_selector.replace('#', '');
        let parent = element.parentNode;
        while(parent.getAttribute('id') !== parent_id) {
            parent = parent.parentNode;
        }
        return parent;
    }
    // Class
    else if(parent_selector.indexOf('.') == 0) {
        let parent_class = parent_selector.replace('.', '');
        let parent = element.parentNode;
        while(!parent.classList.contains(parent_class)) {
            parent = parent.parentNode;
        }
        return parent;
    }
    // Assume it's a tag
    else {
        let parent_tag = parent_selector;
        let parent = element.parentNode;
        while(parent.tagName !== parent_tag.toUpperCase()) {
            parent = parent.parentNode;
        }
        return parent;
    }
}
// Modified from https://stackoverflow.com/questions/29223502/how-to-get-href-of-anchor-when-the-event-target-is-htmlimageelement#answer-29223563
// Finds the anchor tag of an event.target element
const get_anchor_tag = function(target) {
    if(target) {
        while (target) {
            if (target instanceof HTMLAnchorElement) {
              return target;
            }
            target = target.parentNode;
        }
    }
}

// From https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
const get_url_parameter = function(name) {
    let url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

const go_to_url = function(url) {
    window.location.href = url;
};

const hex_to_rgb = function(hex) {
    hex = hex.toString();
    hex = hex.toLowerCase();
    hex = hex.replace('#', '');
    let color_parts;
    if ( hex.length == 3 ) {
        color_parts = [hex.substr(0, 1) + hex.substr(0, 1), hex.substr(1, 1) + hex.substr(1, 1), hex.substr(2,1) + hex.substr(2,1)];
    } else {
        color_parts = [hex.substr(0, 2), hex.substr(2, 2), hex.substr(4,2)];
    }
    let map = {
      '0': 0,
      '1': 1,
      '2': 2,
      '3': 3,
      '4': 4,
      '5': 5,
      '6': 6,
      '7': 7,
      '8': 8,
      '9': 9,
      'a': 10,
      'b': 11,
      'c': 12,
      'd': 13,
      'e': 14,
      'f': 15,
    };
    let rgb = [];
    for(let segment in color_parts) {
        let first_digit = map[color_parts[segment][0]];
        let second_digit = map[color_parts[segment][1]];
        rgb.push((first_digit * Math.pow(16, 1)) + (second_digit * Math.pow(16, 0)));
    }
    return rgb;
};

const is_hidden = function(element) {
    let style = window.getComputedStyle(element);
    return ((style.display === 'none') || (style.visibility === 'hidden'));
};

const last_visible_element = function(elements_wrapper) {
    if(elements_wrapper) {
        let elements = elements_wrapper.children;
        let last_visible;
        if(elements) {
            for (let i = 0; i < elements.length; i++) {
                if (!is_hidden(elements[i])) {
                    last_visible = elements[i];
                }
            }
        }
        return last_visible;
    }
};

const light_or_dark = function(hex_color) {
    let brightness = get_brightness(hex_color);
    return brightness >= 127 ? 'light' : 'dark';
};

// Gets the next key in an object
const next_key = function(obj, current_key) {
    let keys = Object.keys(obj);
    let current_index = keys.indexOf(current_key.toString());
    let next_index = current_index + 1;
    if(next_index >= keys.length) {
        return false;
    } else {
        return keys[next_index];
    }
};

// Convert number digits to words
const number_to_words = function(number) {
    //console.log(number);
    let hyphen      = '-';
    let conjunction = ' and ';
    let separator   = ', ';
    let negative    = 'negative ';
    let decimal     = ' point ';
    let dictionary  = {
        0                   : 'zero',
        1                   : 'one',
        2                   : 'two',
        3                   : 'three',
        4                   : 'four',
        5                   : 'five',
        6                   : 'six',
        7                   : 'seven',
        8                   : 'eight',
        9                   : 'nine',
        10                  : 'ten',
        11                  : 'eleven',
        12                  : 'twelve',
        13                  : 'thirteen',
        14                  : 'fourteen',
        15                  : 'fifteen',
        16                  : 'sixteen',
        17                  : 'seventeen',
        18                  : 'eighteen',
        19                  : 'nineteen',
        20                  : 'twenty',
        30                  : 'thirty',
        40                  : 'forty',
        50                  : 'fifty',
        60                  : 'sixty',
        70                  : 'seventy',
        80                  : 'eighty',
        90                  : 'ninety',
        100                 : 'hundred',
        1000                : 'thousand',
        1000000             : 'million',
        1000000000          : 'billion',
        1000000000000       : 'trillion',
        1000000000000000    : 'quadrillion',
        1000000000000000000 : 'quintillion'
    };
    if(typeof number != 'number') {
        return false;
    }
    if((number >= 0 && number < 0 ) || number < 0 - Number.MAX_SAFE_INTEGER) {
        // overflow
        //console.log('number_to_words only accepts numbers between -' + Number.MAX_SAFE_INTEGER + ' and ' + Number.MAX_SAFE_INTEGER);
        return false;
    }
    if(number < 0) {
        return negative + number_to_words(Math.abs(number));
    }
    let string = null;
    let fraction = null;
    let remainder = null;
    if(String(number).indexOf('.') > -1) {
        let number_array = number.split('.');
        number = number_array[0];
        fraction = number_array[1];
    }
    switch(true) {
        case number < 21:
            string = dictionary[number];
            break;
        case number < 100:
            let tens = (number / 10);
            if(String(tens).indexOf('.') > -1) {
                let tens_array = String(tens).split('.');
                tens = Number(tens_array[0]);
            }
            tens = tens * 10;
            let units = number % 10;
            string = dictionary[tens];
            if(units) {
                string += hyphen + dictionary[units];
            }
            break;
        case number < 1000:
            let hundreds  = number / 100;
            if(String(hundreds).indexOf('.') > -1) {
                let hundreds_array = String(hundreds).split('.');
                hundreds = Number(hundreds_array[0]);
            }
            remainder = number % 100;
            string = dictionary[hundreds] + ' ' + dictionary[100];
            if (remainder) {
                string += conjunction + number_to_words(remainder);
            }
            break;
        default:
            let base_unit = Math.pow( 1000, Math.floor( Math.log( number ) / Math.log(1000) ) );
            let num_base_units = number / base_unit;
            if(String(num_base_units).indexOf('.') > -1) {
                let num_base_units_array = String(num_base_units).split('.');
                num_base_units = Number(num_base_units_array[0]);
            }
            remainder = number % base_unit;
            string = number_to_words( num_base_units ) + ' ' + dictionary[base_unit];
            if(remainder) {
                string += remainder < 100 ? conjunction : separator;
                string += number_to_words(remainder);
            }
            break;
    }
    if(null !== fraction && typeof fraction == 'number') {
        string += decimal;
        let words = [];
        let fraction_array = fraction.split('');
        for(let i = 0;i < fraction_array.length;i++) {
            words.push(dictionary[fraction_array[i]]);
        }
        string += words.join(' ');
    }
    return string;
}

// If the input objects have the same string keys, then the later value for that key will overwrite the previous one
const object_merge = function(obj1, obj2) {
    let obj = obj1;
    for(let key in obj2) {
        obj[key] = obj2[key];
    }
    return obj;
};


const object_sort = function(obj, direction) {
    direction = direction ? direction : 'DESC';
    let array = [];
    for (let key in obj) {
        array.push([key, obj[key]]);
    }
    if (direction == 'DESC') {
        array.sort(function(a, b) {
            return b[1] - a[1];
        });
    } else {
        array.sort(function(a, b) {
            return a[1] - b[1];
        });
    }

    let sorted_obj = {};
    for(let i = 0; i < array.length; i++) {
        let item = array[i];
        if(item[0] && item[1]) {
            sorted_obj[item[0]] = item[1];
        }
    }
    return sorted_obj;
};

const remove_elements = function(elements) {
    elements = elements.length ? elements : [elements];
    for(let i = 0; i < elements.length; i++) {
        if(elements[i] && elements[i].parentNode) {
            elements[i].parentNode.removeChild(elements[i]);
        }
    }
};

const round = function( number, decimals, _chunk ) {
    let chunk = _chunk ? _chunk : 1;
    let rounded = number;
    if ( ! decimals ) {
        rounded = Math.round( number/chunk );
    } else {
        rounded = Math.round( number/(chunk/Math.pow(10, decimals) ) ) / Math.pow(10, decimals);
    }
    return rounded;
};

const sanitize_title_with_dashes = function( string ) {
    return string.toLowerCase().replace(/[\s\_]/g, '-').replace(/[^A-Za-z0-9\-]/g, '');
};

const sort_object_by_field = function(obj, field_key, direction) {
    direction = direction || 'DESC';
    // Create arrays for each obj consisting of the value of the field_key we're sorting by and the obj key
    let obj_array = [];
    for (let key in obj) {
        obj_array.push([obj[key][field_key], key]);
    }
    // Do the actual sorting, based on field_key value
    if (direction == 'DESC') {
        obj_array.sort((a, b) => {
            // Numbers
            if (typeof a[0] == 'number' && typeof b[0] == 'number') {
                return b[0] - a[0];
            }
            // Strings
            else {
                return Number(a[0] > b[0]);
            }
        });
    } else {
        obj_array.sort((a, b) => {
            // Numbers
            if (typeof a[0] == 'number' && typeof b[0] == 'number') {
                return a[0] - b[0];
            }
            // Strings
            else {
                return Number(b[0] > a[0]);
            }
        });
    }
    // Create an array of the sorted objects and return
    let sorted_objs = [];
    for(let i = 0; i < obj_array.length; i++) {
        let sorted_value = obj_array[i][0];
        let obj_key = obj_array[i][1];
        if(sorted_value && obj_key) {
            sorted_objs.push(obj[obj_key]);
        }
    }
    return sorted_objs;
};

/*
 * Uses scripts at chetandube.ai or amelia.ai
 * (whichever is a 3rd party url) to perform a
 * check for 3rd-party cookie support. Sets a
 * session variable called 3rdpartycookies based
 * on the results.
 *
 * Scripts and recieveMessage (below) from
 * https://github.com/mindmup/3rdpartycookiecheck
 *
 */
var thirdpartycookies;
let thirdpartycookiecheck_exists = sessionStorage.getItem('3rdpartycookies') !== null;
if(!thirdpartycookiecheck_exists) {
    let receiveMessage = function (evt) {
        if (evt.data === 'MM:3PCunsupported') {
            sessionStorage.setItem('3rdpartycookies', 0);
        } else if (evt.data === 'MM:3PCsupported') {
            sessionStorage.setItem('3rdpartycookies', 1);
        }
        thirdpartycookies = sessionStorage.getItem('3rdpartycookies');
    };
    window.addEventListener("message", receiveMessage, false);
    let thirdparty_url = home_url.indexOf('https://amelia.ai') > -1 ? 'https://chetandube.ai' : 'https://amelia.ai';
    let thirdparty_iframe = document.createElement('iframe');
    thirdparty_iframe.setAttribute('style', 'display:none');
    thirdparty_iframe.setAttribute('src', thirdparty_url + '/wp-content/themes/amelia-core/libs/3rdpartycookiecheck/start.html');
    document.body.prepend(thirdparty_iframe);
} else {
    thirdpartycookies = sessionStorage.getItem('3rdpartycookies');
}

// Time Ago
// modified from from https://stackoverflow.com/questions/3177836/how-to-format-time-since-xxx-e-g-4-minutes-ago-similar-to-stack-exchange-site
function time_ago(date, _suffix) {
    let suffix = _suffix ? ` ${_suffix}` : '';
    date = typeof date === 'string' ? new Date(date) : date;
    let seconds = Math.floor((new Date() - date) / 1000);

    let years = Math.floor(seconds / 31536000);
    if (years >= 1) {
        let s = years == 1 ? '' : 's';
        return years + ` year${s}${suffix}`;
    }

    let months = Math.floor(seconds / 2592000);
    if (months >= 1) {
        let s = months == 1 ? '' : 's';
        return months + ` month${s}${suffix}`;
    }

    let days = Math.floor(seconds / 86400);
    if (days >= 1) {
        let s = days == 1 ? '' : 's';
        return days + ` day${s}${suffix}`;
    }

    let hours = Math.floor(seconds / 3600);
    if (hours >= 1) {
        let s = hours == 1 ? '' : 's';
        return hours + ` hour${s}${suffix}`;
    }

    let minutes = Math.floor(seconds / 60);
    if (minutes >= 1) {
        let s = minutes == 1 ? '' : 's';
        return minutes + ` minute${s}${suffix}`;
    }

    if (seconds >= 1) {
        let s = seconds == 1 ? '' : 's';
        return Math.floor(seconds) + ` second${s}${suffix}`;
    }

    return "Just now";
}

// Trim character from beginning and end of string - like php trim($str, $char)
const trim_char = function(str, char) {
    if(typeof str != 'string' || typeof char != 'string') {
        return str;
    }
    if(str.charAt(0) == char) {
        str = str.slice(1);
    }
    if(str.charAt(str.length-1) == char) {
        str = str.substr(0, str.length - 1);
    }
    return str;
};

const truncate = function( text, _count, _indicator, _count_type ) {
    if(! text || ! text.length) {
        return text;
    }

    // Set defaults
    let count = _count || 100;
    let indicator = _indicator || '...';
    let indicator_html = `<span class="truncated-indicator">${indicator}</span>`;
    let count_type = _count_type || 'words';
    let min_threshold = count - 7 > 0 ? count - 7 : 0;
    let max_threshold = count + 7;
    let truncated = false;
    // Truncate at end of a sentence
    if(count_type == 'words') {
        let words = text.split(' ');
        if(words.length > count) {
            let periods = array_find('.', words, false);
            for ( let i = 0; i < periods.length; i++ ) {
                let period = Number(periods[i]);
                // If the sentence end is within the min & max threshold, we're done
                if(period >= min_threshold && period <= max_threshold) {
                    truncated = words.slice(0, period + 1).join(' ') + indicator_html;
                    return truncated;
                }
                // If the sentence end is below the min threshold, hang onto it in case we need to return it
                else if(period < min_threshold) {
                    truncated = words.slice(0, period + 1).join( ' ') + indicator_html;
                }
            }
        }
        // If truncating at the end of a sentence did't work, then just end at the word count
        return truncated ? truncated : words.slice(0, count).join( ' ');
    }
    // Truncate at end of a word
    else {
        let spaces = text.search(/\s/g);
        for ( let i = 0; i < spaces.length; i++ ) {
            let space = Number(spaces[i]);
            // If the word end is within the min & max threshold, we're done
            if(space >= min_threshold && space <= max_threshold) {
                truncated = text.slice(0, space + 1) + indicator_html;
                return truncated;
            }
            // If the word end is below the min threshold, hang onto it in case we need to return it
            else if(space < min_threshold) {
                truncated = text.slice(0, space + 1) + indicator_html;
            }
        }
        // If truncating at the end of a word did't work, then just end at the character count
        return truncated ? truncated : text.slice(0, count);
    }
}

// Convert variables with underscores to camelCase
const underscores_to_camelcase = function(string) {
    let underscores = string.match(/_./g);
    if(underscores) {
        // Uppercase the letter after the underscore
        for(let i = 0;i < underscores.length;i++) {
            let upper = underscores[i].toUpperCase();
            string = string.replace(underscores[i], upper);
        }
        // Remove the underscores
        string = string.replace(/_/g, '');
    }
    return string;
}


/*
 * Load Functions
 *
 */

// class go_time {
//     constructor(obj, callback_function, args, customThreshold, fromBottom) {
//         this.threshold = customThreshold !== undefined ? customThreshold : 400;
//         this.windowHeight = window.innerHeight;
//         this.functionName = typeof callback_function == 'object' ? (callback_function[1] ? callback_function[1] : callback_function[0]) : callback_function;
//         this.callback_function = callback_function;
//         this.args = args;
//         this.done = false;
//         let objCoordinates = get_element_offset(obj);
//         let coordinates = fromBottom ? objCoordinates.top + obj.offsetHeight : objCoordinates.top;
//         let scrollTop = document.documentElement.scrollTop;
//         if(this.windowHeight < coordinates + this.threshold && (scrollTop < coordinates - (this.windowHeight + this.threshold))) {
//             document.addEventListener('scroll', this.on_scroll.bind(this, coordinates, obj));
//         } else {
//             this.done = true;
//             this.fire(obj, coordinates);
//         }
//     }
//     on_scroll(coordinates, obj) {
//         let documentScrollTop = document.documentElement.scrollTop;
//         if((documentScrollTop >= coordinates - this.windowHeight + this.threshold && documentScrollTop < obj.offsetHeight + coordinates - this.threshold) && ! this.done) {
//             this.done = true;
//             this.fire(obj, coordinates);
//         }
//     }
//     fire(obj, coordinates) {
//         //console.log(obj);
//         if(typeof this.callback_function == 'object') {
//             let callback_function_class = this.callback_function[0] ? this.callback_function[0] : false;
//             let callback_function_name = this.callback_function[1] ? this.callback_function[1] : false;
//             callback_function_class[callback_function_name](this.args);
//         } else {
//             eval(this.callback_function+'(this.args)');
//         }
//         document.removeEventListener('scroll', this.on_scroll.bind(this, coordinates, obj));
//     }
// };

// Load defered iframes
const load_defered_iframes = function() {
    let iframes = document.getElementsByTagName('iframe');
    if(iframes) {
        for(let i = 0; i < iframes.length; i++) {
            let iframe = iframes[i];
            if(! iframe.classList.contains('ai-lazy') && ! iframe.classList.contains('ai-iframe-page-iframe')) {
                let src_attribute = iframe.getAttribute('src');
                let data_src_attribute = iframe.getAttribute('data-src');
                // If src is blank and data-src exists, set src = data-src
                if( ( (src_attribute && ! src_attribute.length) || ! src_attribute) && data_src_attribute) {
                    iframe.setAttribute('src', data_src_attribute);
                }
            }
        }
    }
};

// Load iframe page iframes
const load_iframe_page_iframes = function() {
    let iframes = document.getElementsByClassName('ai-iframe-page-iframe');
    if(iframes) {
        for(let i = 0; i < iframes.length; i++) {
            let iframe = iframes[i];
            let src_attribute = iframe.getAttribute('src');
            let data_src_attribute = iframe.getAttribute('data-src');
            // If src is blank and data-src exists, set src = data-src
            if( ( (src_attribute && ! src_attribute.length) || ! src_attribute) && data_src_attribute) {
                // If url is local or thirdpartycookies
                if(thirdpartycookies == 1) {
                    // Go ahead and load it into an iframe
                    iframe.setAttribute('src', data_src_attribute);
                } else {
                    // Open in a new tab instead
                    window.location = data_src_attribute;
                }
            }
        }
    }
};
ai_document_ready(load_iframe_page_iframes);

// Load defered embeded videos
const load_defered_bg_video = function() {
    let lazyVideos = [].slice.call(document.querySelectorAll('video.ai-lazy-video'));
    if ('IntersectionObserver' in window) {
        let lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(video) {
                if (video.isIntersecting) {
                    for (let source in video.target.children) {
                        let videoSource = video.target.children[source];
                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }
                    video.target.load();
                    video.target.classList.remove('ai-lazy-video');
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });
        lazyVideos.forEach(function(lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
};

// Load defered forms
const load_defered_forms = function() {
    let forms = hubspot_forms;
    if(forms) {
        for(let i = 0; i < forms.length; i++) {
            if(hubspot_forms_loaded.indexOf(forms[i]) == -1) {
                forms[i]();
            }
        }
    }
};

// Load defered elements
// from https://css-tricks.com/the-complete-guide-to-lazy-loading-images/
const load_defered_elements = function(settings) {
    let lazyloadElements;
    let class_name = settings && settings.class_name ? settings.class_name : 'ai-lazy';
    let class_selector = '.'+class_name;
    let initial_attribute = settings && settings.initial_attribute !== undefined ? settings.initial_attribute : 'data-src';
    let load_attribute = settings && settings.load_attribute !== undefined ? settings.load_attribute : 'src';
    let callback = settings && settings.callback ? settings.callback : false;
    if ('IntersectionObserver' in window) {
        lazyloadElements = document.querySelectorAll(class_selector);
        let elementObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    let element = entry.target;
                    element.classList.remove(class_name);
                    if(initial_attribute && load_attribute) {
                        let initial = element.getAttribute(initial_attribute);
                        let load = element.getAttribute(load_attribute);
                        // If src is blank and data-src exists, set src = data-src
                        if( ( (load && ! load.length) || ! load) && initial) {
                            element.setAttribute(load_attribute, initial);
                        }
                    }
                    if(callback && typeof callback == 'function') {
                        callback(element);
                    }
                    elementObserver.unobserve(element);
                }
            });
        });
        lazyloadElements.forEach(function(element) {
            elementObserver.observe(element);
        });
    } else {
        let lazyloadThrottleTimeout;
        lazyloadElements = document.querySelectorAll(class_selector);
        function lazyload () {
            if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }
            lazyloadThrottleTimeout = setTimeout(function() {
                let scrollTop = window.pageYOffset;
                lazyloadElements.forEach(function(elem) {
                    if(elem.offsetTop < (window.innerHeight + scrollTop)) {
                        if(initial_attribute && load_attribute) {
                            let initial = elem.getAttribute(initial_attribute);
                            let load = elem.getAttribute(load_attribute);
                            // If src is blank and data-src exists, set src = data-src
                            if( ( (load && ! load.length) || ! load) && initial) {
                                elem.setAttribute(load_attribute, initial);
                            }
                        }
                        if(callback && typeof callback == 'function') {
                            callback(elem);
                        }
                        elem.classList.remove(class_selector);
                    }
                });
                if(lazyloadElements.length == 0) {
                    document.removeEventListener('scroll', lazyload);
                    window.removeEventListener('resize', lazyload);
                    window.removeEventListener('orientationChange', lazyload);
                }
            }, 20);
        }
        document.addEventListener('scroll', lazyload);
        window.addEventListener('resize', lazyload);
        window.addEventListener('orientationChange', lazyload);
    }
};

const load_defered_charts = function() {
    let settings = {
        class_name: 'ai-lazy-chart',
        initial_attribute: false,
        load_attribute: false,
        callback: function(element) {
            let callback_function_name = element.getAttribute('data-callback');
            eval(callback_function_name+'();');
        }
    };
    load_defered_elements(settings);
}

const load_defered_twitter = function() {
    let settings = {
        class_name: 'ai-lazy-twitter',
        initial_attribute: false,
        load_attribute: false,
        callback: function(element) {
            let twitter_wrapper = element;
            let twitter_script = document.createElement('script');
            twitter_script.src = 'https://platform.twitter.com/widgets.js';
            twitter_script.charset = 'utf-8';
            twitter_wrapper.appendChild(twitter_script);
        }
    };
    load_defered_elements(settings);
}